import { render, staticRenderFns } from "./popup-edit-snapshot-folder.vue?vue&type=template&id=4c6dc4c3&scoped=true"
import script from "./popup-edit-snapshot-folder.vue?vue&type=script&lang=js"
export * from "./popup-edit-snapshot-folder.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c6dc4c3",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/mira-merge-config/mira-merge-config/app-config/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4c6dc4c3')) {
      api.createRecord('4c6dc4c3', component.options)
    } else {
      api.reload('4c6dc4c3', component.options)
    }
    module.hot.accept("./popup-edit-snapshot-folder.vue?vue&type=template&id=4c6dc4c3&scoped=true", function () {
      api.rerender('4c6dc4c3', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/mprofiles/views/find-user/popups/popup-edit-snapshot-folder.vue"
export default component.exports